export default class ArrayService {
  constructor() {
    'ngInject';
  }

  add(array, obj) {
    return [
      ...array,
      obj
    ];
  }

  remove(array, obj) {
    const index = array.indexOf(obj);

    if (index === -1) {
      throw new Error('Object does not exist in array!');
    }

    return [
      ...array.slice(0, index),
      ...array.slice(index + 1)
    ];
  }

  update(array, obj, index) {
    if (index === -1) {
      throw new Error('Object does not exist in array!');
    }

    return [
      ...array.slice(0, index),
      obj,
      ...array.slice(index + 1)
    ];
  }
}



// WEBPACK FOOTER //
// ./services/array.service.js